<template>
  <div style="padding: 5px;">
    <!-- <a-button :loading="iconLoading" @click="toolCreateMultipleEmployee">
      Clone
    </a-button> -->
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="Code / Mã nhân viên" prop="code">
        <a-input v-model="form.code" placeholder="Write code" />
      </a-form-model-item>
      <a-form-model-item
        has-feedback
        label="Fullname / Họ và tên"
        prop="fullname"
      >
        <a-input
          v-model="form.fullname"
          placeholder="Write fullname / Nhập đầy đủ họ và tên"
        />
      </a-form-model-item>

      <a-form-model-item label="Birthday / Ngày sinh" prop="birthday">
        <a-date-picker
          type="date"
          placeholder="Select date"
          style="width: 100%;"
          format="DD/MM/YYYY"
          v-model="form.birthday"
        />
      </a-form-model-item>
      <a-form-model-item label="Started Date / Ngày vào công ty">
        <a-date-picker
          type="date"
          placeholder="Select date"
          style="width: 100%;"
          format="DD/MM/YYYY"
          v-model="form.startedDate"
        />
      </a-form-model-item>
      <a-form-model-item has-feedback label="Email" prop="email">
        <a-input v-model="form.email" placeholder="Nhập email" />
      </a-form-model-item>
      <a-form-model-item
        has-feedback
        label="Code Department / Mã phòng ban"
        prop="codeDepartment"
      >
        <a-input
          v-model="form.codeDepartment"
          placeholder="Write code department"
        />
      </a-form-model-item>
      <a-form-model-item has-feedback label="Cost Center" prop="costCenter">
        <a-input v-model="form.costCenter" placeholder="Write cost center" />
      </a-form-model-item>
      <a-form-model-item label="Gender / Giới tính" prop="gender">
        <a-select
          allowClear
          placeholder="-Select-"
          v-model="form.gender"
          style="width: 100%;"
        >
          <a-select-option value="NONE">
            Other
          </a-select-option>
          <a-select-option value="MALE">
            Male
          </a-select-option>
          <a-select-option value="FEMALE">
            Female
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Position / Chức vụ" prop="position">
        <SelectPosition
          v-model="form.positionId"
          :selectProps="{
            value: form.positionId,
            style: { width: '100%' },
            placeholder: 'Position',
          }"
        />
      </a-form-model-item>
      <a-form-model-item label="Department / Phòng ban" prop="department">
        <SelectDepartment
          v-model="form.departmentId"
          :selectProps="{
            value: form.departmentId,
            style: { width: '100%' },
            placeholder: 'Department',
          }"
        />
      </a-form-model-item>
      <a-form-model-item label="Location / Địa điểm làm việc">
        <SelectBranchLocation
          v-model="form.branchLocationId"
          :selectProps="{
            value: form.branchLocationId || undefined,
            style: { width: '100%' },
            placeholder: 'Location',
          }"
        />
      </a-form-model-item>
      <a-form-model-item label="Main Shift / Ca làm việc chính thức">
        <SelectWorkShift
          v-model="form.workShiftId"
          :variables-query="{ isOvertime: false }"
          :selectProps="{
            value: form.workShiftId || undefined,
            style: { width: '100%' },
            placeholder: 'Shift',
          }"
        />
      </a-form-model-item>
      <a-form-model-item label="Account / Người dùng" prop="user">
        <SelectUser
          v-model="form.userId"
          :selectProps="{
            placeholder: 'Account',
            style: { width: '100%' },
          }"
        />
      </a-form-model-item>
    </a-form-model>

    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 5px;" @click="closeDrawer">
        <a-icon type="close" /> Close
      </a-button>
      <a-button
        type="primary"
        @click="createEmployee"
        icon="plus"
        :loading="iconLoading"
      >
        Create
      </a-button>
    </div>
  </div>
</template>
<script>
import getQuery from "../data/getData";
import postQuery from "../data/postData";
import changeAlias from "@/services/changeAlias";
import SelectPosition from "@/components/common/position/select";
import SelectDepartment from "@/components/common/department/select";
import SelectBranchLocation from "@/components/common/branchLocation/select";
import SelectWorkShift from "@/components/common/workShift/select";
import SelectUser from "@/components/common/user/select";

export default {
  components: {
    SelectPosition,
    SelectDepartment,
    SelectUser,
    SelectBranchLocation,
    SelectWorkShift,
  },
  props: {
    closeDrawer: {
      type: Function,
    },
    updateListAfterCreated: {
      type: Function,
    },
  },
  data() {
    let checkCode = (rule, value, callback) => {
      if (!this.regCode.test(this.form.code)) {
        callback(
          new Error(
            "Mã nhân viên yêu cầu tối thiểu 4 ký tự, không được trùng, không dấu cách, không dấu,ký tự đặc biệt trừ dấu _"
          )
        );
      } else {
        callback();
      }
    };
    let checkEmail = (rule, value, callback) => {
      if (!this.regEmail.test(this.form.email)) {
        if (this.form.email) {
          callback(
            new Error(
              "Email này không hợp lệ. Hãy đảm bảo rằng email được nhập dưới dạng example@email.com"
            )
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      iconLoading: false,
      form: {
        code: undefined,
        email: undefined,
        fullname: undefined,
        birthday: undefined,
        gender: undefined,
        positionId: undefined,
        departmentId: undefined,
        userId: undefined,
      },
      regEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      regCode: /^\w{4,100}$/,
      rules: {
        code: [
          {
            required: true,
            message: "Required / Mã nhân viên không được bỏ trống",
            trigger: "change",
          },
          { validator: checkCode, trigger: "change" },
        ],
        email: [{ validator: checkEmail, trigger: "change" }],
        fullname: [
          {
            required: true,
            message: "Required / Họ và tên không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    searchFilter(input, option) {
      return (
        changeAlias(option.componentOptions.children[0].text).indexOf(
          changeAlias(input)
        ) >= 0
      );
    },
    goToListEmployee() {
      this.$router.push({
        name: "employee",
      });
    },
    async toolCreateMultipleEmployee() {
      const FULLNAME = "Employee Clone ";
      const CODE = "CLONE_";

      for (let i = 10; i < 300; i++) {
        this.form = {
          fullname: FULLNAME + i,
          code: CODE + i,
        };

        await this.createEmployee();
      }
    },
    createEmployee() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.iconLoading = true;
          this.$apollo
            .mutate({
              mutation: postQuery.queryCreateEmployee,
              variables: {
                ...this.form,
              },
            })
            .then((data) => {
              this.$notification.success({
                message: "Success",
                description: "Updated Success!",
              });
              this.iconLoading = false;
              if (data?.data?.createEmployee?.id) {
                this.updateListAfterCreated(data.data.createEmployee);
              }
              this.form = {};
            })
            .catch((error) => {
              this.$notification.error({
                message: "Error",
                description: "Updated Error!",
              });
              console.log("Không lấy được danh sách nhân viên", error);
              this.iconLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style></style>
